module.exports = __webpack_public_path__ + "static/media/FAS.188438a2.png";